function getUserLocale() {
    if (navigator && navigator.language) {
        return navigator.language
    } else {
        return 'en-US'
    }
}

export function toNumber(n: string): number | undefined {
    const num = Number(n)
    if (isNaN(num) || !isFinite(num)) {
        return undefined
    }
    return num
}

export function formatNumber(num:number, currency:string) {
    const finalNum = isNaN(num) || !isFinite(num) ? 0 : num
    
    const formatter = new Intl.NumberFormat(getUserLocale(), {
            style: 'currency',
            currency,
    })
    
    return formatter.format(finalNum)
}

export function formatNumberLocale(num:number, dec?:number) {
    const finalNum = isNaN(num) || !isFinite(num) ? 0 : num
    const options: Intl.NumberFormatOptions = {
        minimumFractionDigits: typeof dec === 'number' ? dec : 2,
        maximumFractionDigits: typeof dec === 'number' ? dec : 2,
    }


const userLanguage = navigator.language || navigator.languages[0]

return finalNum.toLocaleString(userLanguage, options)
}

export function getCurrencySign(currency: string, ) {
    const locale = getUserLocale()
    
    const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    
    const parts = formatter.formatToParts(1)
    const currencySign = parts.find(part => part.type === 'currency')?.value
    
    return currencySign || ''
}



export function roundNumber(num:number, dec:number) {
    return Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec)
}

const nwColors:{[key:string]:string} = {
    'Adtraction' : '#1f77b4',
    'TradeTracker': '#ff7f0e',
    'Tradedoubler': '#2ca02c',
    'ShareASale': "#9467bd",
    'Rejected':'#d62728',
    'Awin': '#ffbb78',
    "Webgains": "#7f7f7f",
    'Daisycon': '#17becf',
    'PartnerAds': '#e377c2',
    'Addrevenue': '#ff9896',
    'Adcell': '#f7b6d2',
    'Impact': '#bcbd22'
}

const colors = [
    '#98df8a',
    "#8c564b",
    "#c5b0d5",
    "#c49c94",
    "#f7b6d2",
    "#c7c7c7",
    "#9edae5",
    "#ad494a",
    "#8c6d31",
    "#843c39",
    "#3182bd",
    "#e6550d",
    "#31a354",
    "#756bb1",
    "#636363",
    "#3182bd",
  ]

  export function getColor(network:string, i:number) {
    return nwColors[network] || colors[i]
  }

  export function getUserTimezoneOffset() {
    const offsetInMinutes = new Date().getTimezoneOffset()
    return -(offsetInMinutes / 60)
}

export const currencies = ["AED","AFN","ALL","AMD","ANG","AOA","ARS","AUD","AWG","AZN","BAM","BBD","BDT","BGN","BHD","BIF","BMD","BND","BOB","BRL","BSD","BTC","BTN","BWP","BYN","BZD","CAD","CDF","CHF","CLF","CLP","CNH","CNY","COP","CRC","CUC","CUP","CVE","CZK","DJF","DKK","DOP","DZD","EGP","ERN","ETB","EUR","FJD","FKP","GBP","GEL","GGP","GHS","GIP","GMD","GNF","GTQ","GYD","HKD","HNL","HRK","HTG","HUF","IDR","ILS","IMP","INR","IQD","IRR","ISK","JEP","JMD","JOD","JPY","KES","KGS","KHR","KMF","KPW","KRW","KWD","KYD","KZT","LAK","LBP","LKR","LRD","LSL","LYD","MAD","MDL","MGA","MKD","MMK","MNT","MOP","MRU","MUR","MVR","MWK","MXN","MYR","MZN","NAD","NGN","NIO","NOK","NPR","NZD","OMR","PAB","PEN","PGK","PHP","PKR","PLN","PYG","QAR","RON","RSD","RUB","RWF","SAR","SBD","SCR","SDG","SEK","SGD","SHP","SLL","SOS","SRD","SSP","STD","STN","SVC","SYP","SZL","THB","TJS","TMT","TND","TOP","TRY","TTD","TWD","TZS","UAH","UGX","USD","UYU","UZS","VES","VND","VUV","WST","XAF","XAG","XAU","XCD","XDR","XOF","XPD","XPF","XPT","YER","ZAR","ZMW","ZWL"]